import {
  PAGE_LIST_FETCH,
  PAGE_LIST_SUCCESS,
  PAGE_LIST_FAILURE
} from './actionTypes';

//import { ADD_PAGE_TO_THE_LIST } from '../ServiceForm/actionTypes';

const initialState = {
  isLoaded: false,
  pages: [],
  error: []
};

export const pagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_LIST_FETCH:
      return { ...state, isLoaded: false };
    case PAGE_LIST_SUCCESS:
      return { ...state, isLoaded: true, pages: action.payload };
    /*     case ADD_PAGE_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        pages: [...state.pages, action.payload]
      }; */
    case PAGE_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.pageList.isLoaded;
export const getPages = state => state.pageList.pages;
export const getError = state => state.pageList.error;



// WEBPACK FOOTER //
// ./src/modules/PageList/reducer.js